// extracted by mini-css-extract-plugin
module.exports = {"link":"Authenticate_link__2DTP6"};